import React from "react";
import Paper, { PaperProps } from "@mui/material/Paper";

export type EmtPaperProps = Omit<PaperProps, "variant"> & {
  nonce?: string;
  onResizeCapture?: any;
  onResize?: any;
  variant?: "information" | any;
};

export const EmtPaper: JSX.Element & any = React.forwardRef<
  HTMLDivElement,
  EmtPaperProps
>((componentProps, ref) => {
  return <Paper {...componentProps} ref={ref} />;
});

EmtPaper.displayName = "EmtPaper";
